var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66536 5.83398H13.332V14.5007C13.332 14.8688 13.0336 15.1673 12.6654 15.1673H3.33203C2.96384 15.1673 2.66536 14.8688 2.66536 14.5007V5.83398ZM3.9987 7.16732V13.834H11.9987V7.16732H3.9987ZM5.9987 8.50065H7.33203V12.5007H5.9987V8.50065ZM8.66536 8.50065H9.9987V12.5007H8.66536V8.50065ZM4.66536 3.83398V2.50065C4.66536 2.13246 4.96384 1.83398 5.33203 1.83398H10.6654C11.0336 1.83398 11.332 2.13246 11.332 2.50065V3.83398H14.6654V5.16732H1.33203V3.83398H4.66536ZM5.9987 3.16732V3.83398H9.9987V3.16732H5.9987Z",
    fill: "#F06548"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e26a3cb101cb2a5e89b4a3ffe74b20a2.svg";
export { ForwardRef as ReactComponent };